<template>
    <div class="custom_select">
        <span class="fa fa-times clear" v-if="allowEmpty" @click.prevent="clear()"></span>
        <multiselect v-model="model"
                     :id="`currency_select_${_uid}`"
                     label="name"
                     track-by="id"
                     :placeholder="placeholder"
                     :allow-empty="allowEmpty"
                     :options="options"
                     :searchable="true"
                     :loading="isLoading"
                     :block-keys="['Tab']"
                     selectLabel=""
                     selectedLabel=""
                     deselectLabel=""
                     @input="onChange"
        >
            <template slot="noResult">
                {{ $t('no_records_found') }}
            </template>
        </multiselect>
    </div>
</template>

<script>
    import multiselect from 'vue-multiselect'
    import Notify from 'utils/helpers/notify'
    import { trans } from 'utils/helpers/translation'
    import { getCurrencies } from 'services/globals'
    import { find, isNull } from 'lodash'

    export default {
        components: { multiselect },
        data () {
            return {
                model: '',
                options: [],
                isLoading: false
            }
        },
        props: {
            'value': {
                default: () => ''
            },
            'allowEmpty': {
                type: Boolean,
                default: () => true
            },
            'placeholder': {
                type: String,
                default: () => trans('select_an_option')
            }
        },
        mounted () {
            this.loadOptions()
        },
        watch: {
            value (val) {
                this.model = find(this.options, { id: val })
            }
        },
        methods: {
            loadOptions () {
                this.isLoading = true

                getCurrencies()
                    .then((response) => {
                        this.options = response.data
                        this.model = find(this.options, { id: this.value })
                    })
                    .catch(() => Notify.error(trans('sorry_could_not_get_the_currencies_list')))
                    .then(() => { this.isLoading = false })
            },
            onChange (value) {
                isNull(value) ? this.$emit('input', value) : this.$emit('input', value.id)
            },
            clear () {
                this.model = ''
                this.$emit('input', null)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/form/selects/Currencies.vue